import React, { useContext, useEffect, useState } from "react";
import UsersContext from "../Context/UsersContext";
import FarmerTable from "./FarmerTable";
// icons imports
// import { FaList } from "react-icons/fa6";
import SummaryTable from "./SummaryTable";
import FarmerRegister from "./FarmerRegister";
import { IoArrowBack } from "react-icons/io5";
import { IoSettingsSharp } from "react-icons/io5";
import { FaPenNib } from "react-icons/fa";
import FarmerMgmt from "./FarmerMgmt";
import FarmerFinish from "./FarmerFinish";

function FarmerHome() {
  const [show, setShow] = useState(true);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const { farmers, fetchFarmers, user, users } = useContext(UsersContext);
  const userdetails = users?.filter((dt) => dt?.id === user?.id);
  const RegFarmers = farmers?.filter((dt) => dt?.creator_id === user?.id);

  // handle  show farmer management logic
  const handleShow = () => {
    setShow1(true);
    setShow(false);
    setShow2(false);
  };
  // handle show farmer registration form
  const handleShow1 = () => {
    setShow(false);
    setShow2(true);
    setShow1(false);
  };

  // handle show main page from farmer management
  const handleShow3 = () => {
    setShow(true);
    setShow1(false);
    setShow2(false);
  };

  useEffect(() => {
    fetchFarmers();
  }, []);

  return (
    <div>
      {show ? (
        <>
          {/* register farmer button */}
          <div className="flex flex-row items-center justify-between w-full mt-2 mb-10 md:justify-start gap-x-4 ">
            <button
              onClick={handleShow1}
              className="flex flex-row items-center px-4 py-2 text-xs text-white bg-green-600 rounded-lg gap-x-2 md:text-sm"
            >
              <FaPenNib className="text-lg" />
              Register Farmers
            </button>
            <button
              onClick={handleShow}
              className="flex flex-row items-center px-4 py-2 text-xs text-white bg-green-600 rounded-lg gap-x-2 md:text-sm"
            >
              <IoSettingsSharp className="text-lg" />
              Farmer settings
            </button>
          </div>
          {/* stats summarry */}
          <SummaryTable RegFarmers={RegFarmers} userdetails={userdetails} />
          {/* Farmers table */}
          <div className="flex flex-row gap-2 mt-10 mb-5">
            {/* <FaList className="md:text-lg " /> */}
            <h1 className="text-sm dark:text-gray-300 md:text-sm">
              List of Farmers Enrolled by
              <span className="px-1 ">{userdetails[0]?.name}</span>
            </h1>
          </div>
          {/* Farmers Table */}
          <FarmerTable users={RegFarmers} />

          {/* finished Farmers */}
          <FarmerFinish users={RegFarmers} />
        </>
      ) : show2 ? (
        <>
          <div
            onClick={() => setShow(true)}
            className="mb-5 dark:text-gray-300 cursor-pointer flex flex-row items-center gap-x-3  w-[100px] py-1"
          >
            <IoArrowBack className="text-2xl" />
            <h1 className="text-xs md:text-sm">Back</h1>
          </div>
          <FarmerRegister
            FamaId={userdetails[0]?.user_id}
            creator_id={user.id}
            creator_village={userdetails[0]?.village_id}
            farmers={RegFarmers}
          />
        </>
      ) : (
        ""
      )}

      {show1 ? (
        <>
          {/* Farmer management section */}
          <div
            onClick={handleShow3}
            className="mb-5 dark:text-gray-300 cursor-pointer flex flex-row items-center gap-x-3  w-[100px] py-1"
          >
            <IoArrowBack className="text-2xl" />
            <h1 className="text-xs md:text-sm">Back</h1>
          </div>
          <div className="mt-10 mb-10">
            <SummaryTable RegFarmers={RegFarmers} userdetails={userdetails} />
          </div>

          <FarmerMgmt users={RegFarmers} />
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default FarmerHome;
